/** @typedef {string} QuestionnaireVersion */
export const QUESTIONNAIRE_VERSION_1 = '1';
export const QUESTIONNAIRE_VERSION_2 = '2';
/** @enum {QuestionnaireVersion} */
export const QUESTIONNAIRE_VERSION = {
	V1: QUESTIONNAIRE_VERSION_1,
	V2: QUESTIONNAIRE_VERSION_2,
};
/** @type {QuestionnaireVersion[]} */
export const QUESTIONNAIRE_VERSIONS = [
	QUESTIONNAIRE_VERSION_1,
	QUESTIONNAIRE_VERSION_2,
];
